(() => {
  const BLOCKED_PLAN_IDS = new Set(['689378787664']);
  const HAS_FLAG = (s) => (s || '').toLowerCase().replace(/\s+/g, '').includes('{{h}}');
  const IS_ADDON = (s) => /add-?on/i.test(s || '');

  // ----- deep query (pierces shadow roots) -----
  function queryAllDeep(root, selector) {
    const out = [];
    const visit = (node) => {
      if (!node) return;
      if (node instanceof Element && node.matches(selector)) out.push(node);
      // Light DOM children
      node.childNodes && node.childNodes.forEach(visit);
      // Shadow DOM
      if (node.shadowRoot) visit(node.shadowRoot);
      // Iframes (just in case)
      if (node.tagName === 'IFRAME') {
        try { visit(node.contentDocument); } catch (_) {}
      }
    };
    visit(root);
    return out;
  }

  function isBlocked(opt) {
    const val  = opt.value || '';
    const text = (opt.textContent || '').trim();
    const meta = opt.getAttribute?.('data-internal-properties') || '';
    return BLOCKED_PLAN_IDS.has(val) || HAS_FLAG(text) || HAS_FLAG(meta) || IS_ADDON(text) || IS_ADDON(meta);
  }

  function firstEnabled(select) {
    const idx = Array.from(select.options).findIndex(o => !o.disabled && !isBlocked(o));
    return idx === -1 ? 0 : idx;
  }

  function pruneSelect(select) {
    if (!select) return false;
    let changed = false;

    // Remove from the end to avoid index shifts
    for (let i = select.options.length - 1; i >= 0; i--) {
      const o = select.options[i];
      if (isBlocked(o)) {
        try {
          o.remove();
          console.debug('[Upcart Prune] removed option', { value: o.value, text: o.textContent });
        } catch {
          // Some renderers "own" the node — hide+disable as fallback
          o.hidden = true; 
          o.disabled = true;
          o.label = ''; 
          o.textContent = '';
          console.debug('[Upcart Prune] hid+disabled option', { value: o.value });
        }
        changed = true;
      }
    }

    if (select.options.length === 0) {
      select.disabled = true;
      console.debug('[Upcart Prune] select disabled (no options left)');
      return changed;
    }

    // Ensure valid selection
    if (select.selectedIndex < 0 || isBlocked(select.options[select.selectedIndex]) || select.options[select.selectedIndex]?.disabled) {
      const idx = firstEnabled(select);
      if (idx >= 0) {
        select.selectedIndex = idx;
        changed = true;
        console.debug('[Upcart Prune] forced selection', { index: idx, value: select.value });
      }
    }

    if (changed) {
      select.dispatchEvent(new Event('input',  { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return changed;
  }

  function guardSelection(select) {
    // If a blocked option ever gets selected, bounce it to the first allowed
    select.addEventListener('change', () => {
      const opt = select.options[select.selectedIndex];
      if (opt && isBlocked(opt)) {
        const idx = firstEnabled(select);
        if (idx >= 0 && idx !== select.selectedIndex) {
          select.selectedIndex = idx;
          select.dispatchEvent(new Event('input',  { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
          console.debug('[Upcart Guard] blocked selection intercepted; switched to', { index: idx, value: select.value });
        }
      }
    }, true);
  }

  function runOnce(label = '') {
    const roots = [document];
    // Collect shadow roots off the main document (quick scan)
    document.querySelectorAll('*').forEach(el => { if (el.shadowRoot) roots.push(el); });

    let found = 0, pruned = 0;
    roots.forEach(root => {
      const selects = queryAllDeep(root, 'select.upcart-subscription-upgrade-dropdown');
      found += selects.length;
      selects.forEach(sel => {
        guardSelection(sel);
        if (pruneSelect(sel)) pruned++;
      });
    });
    console.debug(`[Upcart Run${label ? ' - ' + label : ''}] selects found: ${found}, pruned/changed: ${pruned}`);
  }

  // Initial + staggered passes (to beat React reflows)
  runOnce('init');
  setTimeout(() => runOnce('250ms'), 250);
  setTimeout(() => runOnce('1s'), 1000);
  setTimeout(() => runOnce('2s'), 2000);

  // rAF loop (aggressive but lightweight) for 5 seconds
  const endAt = performance.now() + 5000;
  (function loop() {
    runOnce('raf');
    if (performance.now() < endAt) requestAnimationFrame(loop);
  })();

  // Global mutation observer (document level) to react to any re-render
  const mo = new MutationObserver(muts => {
    for (const m of muts) {
      if (m.type === 'childList' || (m.type === 'attributes' && m.target && (m.target.matches?.('select.upcart-subscription-upgrade-dropdown') || m.attributeName === 'data-internal-properties'))) {
        runOnce('MO');
        break;
      }
    }
  });
  mo.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-internal-properties', 'class'] });

  // Listen on window & document for Upcart/Aftersell events
  ['aftersell-upcart:public-events:cart-updated', 'aftersell-upcart:public-events:cart-opened']
    .forEach(evt => {
      window.addEventListener(evt, () => runOnce(evt));
      document.addEventListener(evt, () => runOnce(evt));
    });

  console.debug('[Upcart Prune] armed');
})();